import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const PortalContext = createContext(null);

// previewClientId is set when a TAG admin opens "Client view preview"; every call then carries ?client_id= and the backend audits it.
export function PortalProvider({ previewClientId = null, children }) {
  const [account, setAccount] = useState(null);
  const [error, setError] = useState("");
  const params = useMemo(() => (previewClientId ? { client_id: previewClientId } : {}), [previewClientId]);
  const get = useCallback((path, extra = {}) => api.get(`/client-portal${path}`, { params: { ...params, ...extra } }), [params]);
  const load = useCallback(async () => {
    try {
      const response = await get("/account");
      setAccount(response.data);
      setError("");
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "The portal could not be loaded.");
    }
  }, [get]);
  useEffect(() => { load(); }, [load]);
  const value = useMemo(() => ({ get, account, reloadAccount: load, error, preview: Boolean(previewClientId), previewClientId }), [get, account, load, error, previewClientId]);
  return <PortalContext.Provider value={value}>{children}</PortalContext.Provider>;
}

export function usePortal() {
  return useContext(PortalContext);
}

export const STATUS_TONES = {
  "Request received": "neutral", "Awaiting consent": "neutral", "Provider assigned": "teal", "Testing scheduled": "teal", "Testing complete": "teal",
  "Report in review": "gold", "Report ready": "blue", "Request closed": "muted",
};

export const greeting = () => {
  const hour = new Date().getHours();
  return hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
};

export const longDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
